import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit
} from '@angular/core';
import {ReviseService} from '../../services/revise.service';
import {
  WorkflowBarActionsCreatorService
} from '../../../shared/components/workflow-bar/services/workflow-bar-actions-creator.service';
import {DynamicModalLoaderService} from '../../../layout/services/dynamic-modal-loader.service';
import {WorkflowService} from '../../services/workflow.service';
import {WorkflowConfigService} from '../../services/workflow-config.service';
import {ReviseComponent} from "@ispm/workflow/components/revise/revise.component";
import {ConfigurationStoreHandler} from "../../../configuration/services/configuration-store-handler.service";

@Component({
  selector: 'gen-back',
  templateUrl: './back.component.html',
  styleUrls: ['./back.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class BackComponent extends ReviseComponent implements OnInit, OnChanges, OnDestroy {
  constructor(protected workflowBarAC: WorkflowBarActionsCreatorService,
              protected reviseService: ReviseService,
              protected workflowConfigService: WorkflowConfigService,
              protected popupLoader: DynamicModalLoaderService,
              protected changeDetector: ChangeDetectorRef,
              protected workflowService: WorkflowService,
              protected _zone: NgZone,
              protected configurationStoreHandler: ConfigurationStoreHandler) {
    super(workflowBarAC, reviseService, workflowConfigService, popupLoader, changeDetector, workflowService, _zone, configurationStoreHandler);
  }

  public back() {
    if (!this.disabled) {
      this.reviseService.backToPreviousStep({
        revisionCheckpoint: this.backCheckpoint,
        revisionId: this.revisionId,
        workflowId: this.workflow.id
      })
        .subscribe(res => {
          if (res) {
            this.reviseCompleted.emit(res);
          }
        });
    }
  }
}


